const style = {
    delete: {
        color: 'red'
    }
}

export default style;
